/* ══════════════════════════════════════════════════════════════════════════════════════════════
   Newsletter-Anmeldung direkt an Klaviyo (22.10.2026, User „B“: eigene Felder behalten, nur Klaviyo als Weg).
   Vorher: Shopify-Kundenformular (form 'customer') → Shopify schickte je nach Store-Einstellung eine eigene Bestätigungs-Mail,
   Klaviyo eine zweite. Jetzt geht jede Anmeldung an die Liste „Newsletter (B2C) (Website Signups)“ (QTFtwP, Double-Opt-in);
   die Bestätigungs-Mail kommt nur von Klaviyo, danach startet die Willkommensserie. Gleiche Schnittstelle wie das
   Benachrichtigen-Formular (assets/rd-dialoge.js). Checkout- und Login-Häkchen sind davon unberührt.
   Markup: <form data-rd-nl data-rd-nl-quelle="Startseite|Footer|Magazin|…"> mit input[type=email], [data-rd-nl-zeile],
   [data-rd-nl-fehler] (data-text-ungueltig, data-text-netz) und [data-rd-nl-ok] (Danke-Text). Ereignis rd_nl_signup {quelle}.
   ══════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.rdNl) return;
  window.rdNl = true;
  var CO = 'Vs5ixY', LIST = 'QTFtwP', REV = '2024-10-15';
  var gueltig = function (m) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m); };
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function fehler(f, inp, art) {
    var el = f.querySelector('[data-rd-nl-fehler]');
    if (!el) return;
    el.textContent = el.getAttribute(art === 'netz' ? 'data-text-netz' : 'data-text-ungueltig') || '';
    el.hidden = false;
    if (art !== 'netz' && inp) { inp.setAttribute('aria-invalid', 'true'); inp.focus(); }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('form[data-rd-nl]') : null;
    if (!f) return;
    e.preventDefault();
    var inp = f.querySelector('input[type=email]');
    var btn = f.querySelector('[type=submit]');
    var err = f.querySelector('[data-rd-nl-fehler]');
    var mail = ((inp && inp.value) || '').trim();
    if (err) err.hidden = true;
    if (inp) inp.removeAttribute('aria-invalid');
    if (!gueltig(mail)) { fehler(f, inp, 'ungueltig'); return; }
    var quelle = f.getAttribute('data-rd-nl-quelle') || 'Website';
    if (btn) btn.disabled = true;
    f.setAttribute('aria-busy', 'true');
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Website Newsletter – ' + quelle, profile: { data: { type: 'profile', attributes: { email: mail } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
    }).then(function (r) {
      if (!r.ok) throw new Error('nl ' + r.status);
      f.classList.add('is-angemeldet');
      f.querySelectorAll('[data-rd-nl-zeile]').forEach(function (z) { z.hidden = true; });
      var ok = f.querySelector('[data-rd-nl-ok]');
      if (ok) { ok.hidden = false; ok.focus(); }
      track('rd_nl_signup', { quelle: quelle });
    }).catch(function () {
      fehler(f, inp, 'netz');
    }).then(function () {
      if (btn) btn.disabled = false;
      f.removeAttribute('aria-busy');
    });
  }, true);
})();
